import React from "react";

const JoinRm = () => {
  return (
    <div className="flexing">
      <div className="joinrm">
        <h1>Be a Part of the Story of</h1>
        <h1>Cutting-Edge Digital Products</h1>
        <p>
          Join an amazing team of engineers, innovators, and thinkers with
          endless opportunities for you to learn, grow, and thrive.
        </p>
      </div>
      <div className="imgpyramid">
        <img
          src="https://www.simform.com/wp-content/uploads/2024/12/careers-hero-image.svg"
          alt=""
        />
      </div>
    </div>
  );
};

export default JoinRm;
